import { Box } from '@mui/material';

/**
 * @typedef {Object} LogoProps
 * @property {() => void} [onClick] - Optional click handler for logo interaction
 * @property {string} [className] - Additional CSS classes
 * @property {Object} [sx] - Additional Material-UI sx props
 * @property {string} [alt] - Alt text for the logo image
 */

/**
 * Ready Secure Managed Cloud (RSMC) Logo component
 *
 * A reusable logo component that displays the Ready Secure Managed Cloud
 * branding with consistent styling and optional click functionality.
 *
 * @param {LogoProps} props - Component props
 * @returns {JSX.Element} Ready Secure Managed Cloud logo
 */
function Logo({
  onClick,
  className,
  sx = {},
  alt = 'Ready Secure Managed Cloud Logo',
}) {
  return (
    <Box
      component="img"
      src="/logos/rsmc-logo-white.png"
      alt={alt}
      className={className}
      onClick={onClick}
      sx={{
        height: '40px',
        width: 'auto',
        maxWidth: '200px',
        cursor: onClick ? 'pointer' : 'default',
        objectFit: 'contain',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': onClick
          ? {
              transform: 'scale(1.05)',
            }
          : {},
        ...sx,
      }}
    />
  );
}

export default Logo;
